import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { HiOutlineTrash } from "react-icons/hi2";
import { LuCopy, LuGripVertical, LuPencil } from "react-icons/lu";
import { entityKey } from "../../hooks/useMenuEditor";
import { resolveMediaUrl } from "../../utils/mediaUrl";
import { parsePersianNumber } from "../../utils/persianNumber";

import { formatPersianNumber as priceFormatter } from "../../utils/persianNumber";

const SortableMenuItem = ({ item, onEdit, onDuplicate, onDelete }) => {
  const id = entityKey(item);
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

  return (
    <article
      ref={setNodeRef}
      style={{ transform: CSS.Transform.toString(transform), transition }}
      className={`flex flex-col gap-3 rounded-xl border border-gray-100 bg-white p-3 sm:flex-row sm:items-center ${isDragging ? "z-10 opacity-70 shadow-md" : ""}`}
    >
      <div className="flex min-w-0 flex-1 gap-3">
        <button {...attributes} {...listeners} type="button" aria-label={`جابجایی ${item.name}`} className="cursor-grab touch-none self-center rounded-lg p-2 text-gray-400 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary/30"><LuGripVertical /></button>
        <div className="h-16 w-16 shrink-0 overflow-hidden rounded-lg bg-gray-100">
          {item.image ? <img src={resolveMediaUrl(item.image)} alt={item.name} className="h-full w-full object-cover" /> : <span className="flex h-full items-center justify-center px-1 text-center text-[10px] text-gray-400">بدون تصویر</span>}
        </div>
        <div className="min-w-0 flex-1">
          <p className="truncate font-bold text-gray-800">{item.name}</p>
          <p className="mt-1 text-sm font-semibold text-gray-700">{priceFormatter(parsePersianNumber(item.price) || 0)} تومان</p>
          {item.description && <p className="mt-1 line-clamp-1 text-xs text-gray-500">{item.description}</p>}
        </div>
      </div>
      <div className="flex items-center justify-end gap-1">
        <button type="button" onClick={onEdit} aria-label={`ویرایش ${item.name}`} title="ویرایش" className="rounded-lg p-2.5 text-secondary hover:bg-secondary/10 focus:outline-none focus:ring-2 focus:ring-secondary/30"><LuPencil /></button>
        <button type="button" onClick={onDuplicate} aria-label={`کپی ${item.name}`} title="کپی" className="rounded-lg p-2.5 text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300"><LuCopy /></button>
        <button type="button" onClick={onDelete} aria-label={`حذف ${item.name}`} title="حذف" className="rounded-lg p-2.5 text-red-600 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-200"><HiOutlineTrash /></button>
      </div>
    </article>
  );
};

export default SortableMenuItem;
